module.exports = __webpack_public_path__ + "img/0a8c620eeef67649049946c35988dff27895dfa0.39690ef8.jpg";